import { Card, CardContent } from '@mui/material'
import React from 'react'
import { CardTitle } from './card-title.component'
import { LineChartComponent } from './line.component'

export const ScatterComponent = ({ series, setSelectedZone }) => {
    return (
        <Card>
            <CardContent style={{ position: 'relative' }}>
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                    }}
                >
                    <CardTitle title={'Résilience'} />
                </div>
                <br />
                {series?.length > 0 ? (
                    <LineChartComponent
                        toggle={false}
                        series={series}
                        exporting={false}
                        zoomBySingleTouch={true}
                        tooltip={{
                            formatter: function () {
                                return `${this.point.name || ''} (${this.point.x}°C, ${this.point.y}°C)`
                            },
                        }}
                        plotOptions={{
                            column: {
                                stacking: 'normal',
                                pointWidth: 40,
                                borderRadius: 2,
                            },
                            series: {
                                animation: false,
                            },
                            areaspline: {
                                fillOpacity: 0.4,
                            },
                            chart: {
                                margin: 0,
                            },
                            states: {
                                hover: {
                                    enabled: false,
                                },
                            },
                            scatter: {
                                point: {
                                    events: {
                                        click: function () {
                                            setSelectedZone(this.id)
                                        },
                                    },
                                },
                            },
                        }}
                        type="scatter"
                        yAxis={{
                            title: {
                                text: 'Température mesurée en ON (°C)',
                            },
                        }}
                        xAxis={{ title: { text: 'Température demandée (°C)' } }}
                    />
                ) : null}
            </CardContent>
        </Card>
    )
}
